import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Table from '../Table/Table';
import './tabbed-table.scss';
import RecordPerPage from '../RecordPerPage/RecordPerPage';
import { useDispatch, useSelector } from 'react-redux';
import { currentTabIndexAction } from '../../hooks/currenttabIndexAction';
import { reduxPage } from '../../Core/store';
import cookies from 'next-cookies';

const TabbedTable = (
    {
        allTabData,
        tableData,
        handleSort = () => { },
        tableSortDirection,
        tableSortColumn,
        identityVisible = true,
        setShowTableActionBar,
        setTableActionBarNumSelected,
        setTableActionBarNumTotal,
        getRowMenu = () => { },
        getRowCta = () => { },
        showRowCta = false,
        showSelect = true,
        activeTabIndex = 0,
        setActiveTabIndex,
        tabRecordCounts,
        totalRecordCount,
        currentTabTotalRecordCount,
        tabContainerBackgroundColor = '',
        noDataDescription,
        noDataCtaLabel,
        noDataCtaOnClick,
        selectedRowsData,
        setSelectedRowsData = () => { },
        setSelectedRows = () => { },
        setRemoveRows = () => { },
        setSelectedRowsAll = () => { },
        setCurrentSearchTermsScholarship,
        setCurrentSearchKeyScholarship,
        accountData,
        selectedRows = "",
        selectedRowsAll = "",
        removeRows = "",
        isLoading = false,
        setIsLoading,
        clickTableDataView = () => { },
        isPeopleShowRole = false,
        setItemCountOnPage = () => { },
        itemCountOnPage,
        setCurrentPage = () => { },
        isScholarshipPage,
        page,
        showRecordsPerPage = true,
        updateTotalRecords = false,
        setUpdateTotalRecords = () => { },
        isDisbursementPage = false,
        showResetPasswordBtn = true,
        handleResetPasswordClick = () => { },
        pageType =  '',
        showBlankHeader
    }) => {

    // Gather Application table data
    const [activeColumnData, setActiveColumnData] = useState(allTabData[0]);
    const [selectedRowsAllNewSelect, setSelectedRowsAllNewSelect] = useState("");
    const isBackButtonClicked = useSelector((state) => state.backButtonClicked)

    let userContext = cookies('context').context === 'DONOR' || cookies('context').context === "REVIEWER"

    // const [
    //     isLoading, setIsLoading,
    // ] = useState(true)

    useEffect(() => {
        setIsLoading(false)
    }, [tableData])

    useEffect(() => {
      if (isBackButtonClicked) {
        setActiveColumnData(allTabData[activeTabIndex]);
      }
    }, []);

    const dispatch = useDispatch();
    /**
     * Checks the total number of records for the tab based on the
     * status that tab represents.
     * @param {object} tab
     * @returns {*|number}
     */
    const getTabRecordCount = (tab) => {
        const tabStatus = tab.status_for_api_call__c;
        const recordCount = tabRecordCounts[tabStatus];

        return tabStatus === 'All' ? totalRecordCount : recordCount ? recordCount : 0;
    };



    /**
     * Renders the table tabs for each table view.
     * @param {object[]} tabData
     * @returns {*}
     */
    const renderTabs = (tabData) => {
        return tabData.map((item, index) => {
            const isActive = index === activeTabIndex;
            return (
                <button
                    className={`tabbed-table__tab ${isActive ? 'active' : ''}`}
                    key={`tabbed-table-tab-${index}`}
                    onClick={() => handleTabClick(index)}
                    id={`${pageType == 'APPLICATIONS' ? 'applications-tab-color' : ''}`}
                >
                    <div className='tabbed-table__tab-text'>
                        <span className='tabbed-table__tab-record-count H3BlackDesktop'>
                            {isActive && !isLoading ? (currentTabTotalRecordCount ? currentTabTotalRecordCount : 0) : (getTabRecordCount(item) ? getTabRecordCount(item) : 0)}
                        </span>
                        <span className='CTABlack'>{item.subtab_name__c}</span>
                    </div>

                </button>
            );
        });
    }

    /**
     * Updates the active tab and columns.
     * @param {number} index
     */
    const handleTabClick = (index) => {
        dispatch(currentTabIndexAction(index , itemCountOnPage))
        if (isLoading) {
            return
        }
        if (index === activeTabIndex) {
            setIsLoading(false)
        } else {
            setIsLoading(true)
        }
        if (isDisbursementPage) {
            setUpdateTotalRecords(false)
        }
        setSelectedRows("")
        setSelectedRowsData([])
        setRemoveRows("")
        setSelectedRowsAll("")
        setSelectedRowsAllNewSelect("")
        setActiveTabIndex(index);
        setActiveColumnData(allTabData[index]);
    }

    return (
        <div className='tabbed-table'>
            <div className='tabbed-table__tab-container' style={tabContainerBackgroundColor ? { backgroundColor: tabContainerBackgroundColor } : {}}>
                <div>
                    {renderTabs(allTabData)}
                </div>

               {userContext && showRecordsPerPage && currentTabTotalRecordCount > 10 && <RecordPerPage 
                 setItemCountOnPage={setItemCountOnPage}
                 itemCountOnPage={itemCountOnPage}
                 setCurrentPage={setCurrentPage}
                 isScholarshipPage={isScholarshipPage}
                 page = {page}
                /> 
                }
            </div>

            <Table
                columnData={activeColumnData}
                tableData={tableData}
                identityVisible={identityVisible}
                setCurrentSearchKeyScholarship={setCurrentSearchKeyScholarship}
                handleSort={handleSort}
                currentSortColumn={tableSortColumn}
                currentSortDirection={tableSortDirection}
                setShowTableActionBar={setShowTableActionBar}
                setTableActionBarNumSelected={setTableActionBarNumSelected}
                setTableActionBarNumTotal={setTableActionBarNumTotal}
                getRowMenu={getRowMenu}
                clickTableDataView={clickTableDataView}
                setCurrentSearchTermsScholarship={setCurrentSearchTermsScholarship}
                getRowCta={getRowCta}
                accountData={accountData}
                currentTabTotalRecordCount={currentTabTotalRecordCount}
                showSelect={showSelect}
                showRowCta={showRowCta}
                isLoading={isLoading}
                selectedRows={selectedRows}
                selectedRowsData={selectedRowsData}
                setSelectedRowsData={setSelectedRowsData}
                setSelectedRowsAllNewSelect={setSelectedRowsAllNewSelect}
                selectedRowsAllNewSelect={selectedRowsAllNewSelect}
                selectedRowsAll={selectedRowsAll}
                removeRows={removeRows}
                setSelectedRows={setSelectedRows}
                setRemoveRows={setRemoveRows}
                setSelectedRowsAll={setSelectedRowsAll}
                noDataDescription={noDataDescription}
                noDataCtaLabe={noDataCtaLabel}
                noDataCtaOnClick={noDataCtaOnClick}
                isPeopleShowRole={isPeopleShowRole}
                showResetPasswordBtn = {showResetPasswordBtn}
                handleResetPasswordClick = {handleResetPasswordClick}
                pageType = {pageType}
                showBlankHeader={showBlankHeader}
            />
        </div>
    );
}

// handle proptypes
TabbedTable.propTypes = {
    showBlankHeader: PropTypes.bool,

  };
export default reduxPage(TabbedTable)